import React from 'react';
import LogoSecondLane from '../../assets/logoSecondLane.svg';
import Navbar from '../../assets/Navbar.svg';
import SLRectangle from '../../assets/SL-Rectangle.svg';
import SLLinesLonger from '../../assets/SL-Lines-Longer.svg';
import styles from './MobilePWALandingScreen.module.css';

const MobilePWALandingScreen: React.FC = () => {
  return (
    <div className="h-screen w-full relative overflow-hidden">
      {/* SL-Rectangle as full-screen background */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src={SLRectangle} 
          alt="Background" 
          className="w-full h-full object-cover"
          style={{
            objectPosition: 'center',
            objectFit: 'cover'
          }}
        />
      </div>

      {/* SL-Lines on the right-hand side */}
      <div className="absolute top-0 right-0 w-[85%] h-full">
        <img 
          src={SLLinesLonger} 
          alt="SL Lines" 
          className="w-full h-full object-cover"
          style={{
            objectPosition: 'right center',
            objectFit: 'cover'
          }}
        />
      </div>

      {/* Logo at the top */}
      <div className="absolute top-8 left-4 z-10">
        <img 
          src={LogoSecondLane} 
          alt="SecondLane Logo" 
          className={styles['responsive-logo']}
        />
      </div>

      {/* Navbar at the bottom */}
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 z-10">
        <img 
          src={`${Navbar}?v=${Date.now()}`}
          alt="Navigation Bar" 
          className={styles['responsive-navbar']}
        />
      </div>
    </div>
  );
};

export default MobilePWALandingScreen; 